"use strict";

exports.__esModule = true;
exports.default = void 0;
var _recompose = require("../recompose");
var _styled = require("../styled");
var sort = function sort(key, ascending) {
  return function (itemA, itemB) {
    var a = (0, _styled.prop)(key)(itemA);
    var b = (0, _styled.prop)(key)(itemB);
    if (typeof a === 'number' && typeof b === 'number') {
      return ascending ? a - b : b - a;
    } else if (a > b) {
      return ascending ? 1 : -1;
    } else if (a < b) {
      return ascending ? -1 : 1;
    }
    return 0;
  };
};
var withSorting = (0, _recompose.compose)((0, _recompose.withState)('sorting', 'setSorting', {
  key: undefined,
  ascending: true
}), (0, _recompose.withProps)(function (_ref) {
  var items = _ref.items,
    _ref$sorting = _ref.sorting,
    key = _ref$sorting.key,
    ascending = _ref$sorting.ascending;
  return {
    items: key ? items.slice().sort(sort(key, ascending)) : items
  };
}));
var _default = exports.default = withSorting;